/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramTransactionsWebhookControllerCardComWebhookMutationRequest,
  TelegramTransactionsWebhookControllerCardComWebhookMutationResponse,
} from '../types/TelegramTransactionsWebhookControllerCardComWebhook.ts';

function getTelegramTransactionsWebhookCardComWebhookUrl() {
  const res = { method: 'POST', url: `/api/telegram/transactions/webhook/cardcom` as const };
  return res;
}

/**
 * {@link /api/telegram/transactions/webhook/cardcom}
 */
export async function telegramTransactionsWebhookCardComWebhook(
  data: TelegramTransactionsWebhookControllerCardComWebhookMutationRequest,
  config: Partial<RequestConfig<TelegramTransactionsWebhookControllerCardComWebhookMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramTransactionsWebhookControllerCardComWebhookMutationResponse,
    ResponseErrorConfig<Error>,
    TelegramTransactionsWebhookControllerCardComWebhookMutationRequest
  >({
    method: 'POST',
    url: getTelegramTransactionsWebhookCardComWebhookUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
